import React, { useState, useEffect } from 'react';
import CrudPage from '../../components/CrudPage';
import { tagsApi, sectionApi } from '../../services/adminApi';

const TagsPage = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await sectionApi.getAll();
        const data = response?.data?.[0] || response?.data || [];
        setSections(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Failed to fetch sections:', error);
      }
    };
    fetchSections();
  }, []);

  const columns = [
    { header: 'ID', field: 'tagId' },
    { header: 'Label', field: 'label' },
    { header: 'Section', field: 'sectionId', render: (value, item) => {
      const section = sections.find(s => s.id === value);
      return section ? section.sectionName : value || '-';
    }},
    { header: 'Unit', field: 'unit' },
    { header: 'Icon', field: 'fontAwesomeId', render: (value) => {
      if (!value) return '-';
      return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className={value} style={{ fontSize: '16px' }} />
          <span style={{ fontSize: '12px', color: '#666' }}>{value}</span>
        </span>
      );
    }},
  ];

  const sectionOptions = sections.map(s => ({ value: s.id, label: s.sectionName }));

  const formFields = [
    { name: 'label', label: 'Label', type: 'text', required: true },
    { name: 'sectionId', label: 'Section', type: 'select', options: sectionOptions },
    { name: 'unit', label: 'Unit', type: 'text', placeholder: 'e.g., %, sqft, kWh' },
    { name: 'imageUrl', label: 'Image URL', type: 'text' },
    { name: 'fontAwesomeId', label: 'FontAwesome ID', type: 'text', placeholder: 'e.g., fa-solid fa-bolt' },
  ];

  return (
    <CrudPage
      title="Tags"
      subtitle="Manage property tags"
      api={tagsApi}
      columns={columns}
      formFields={formFields}
      idField="tagId"
      searchField="label"
    />
  );
};

export default TagsPage;
